export default [
  {
    path: '/transfer-history',
    name: 'transfer-history',
    component: () => import('@/views/modules/transfer-history/TransferHistory.vue'),
    meta: { requiresAuth: true },
  },
];